'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _ramda = require('ramda');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reduxConnect = require('redux-connect');
var _reactRouter = require('react-router');

var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _constants = require('../../constants');
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);

var _articles = require('../../redux/modules/articles');

var _ArticlesPage = require('./ArticlesPage.scss');var _ArticlesPage2 = _interopRequireDefault(_ArticlesPage);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
// Redux
// Styles
var ArticlesPage = function (_Component) {_inherits(ArticlesPage, _Component);function ArticlesPage() {var _temp, _this, _ret;_classCallCheck(this, ArticlesPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderArticle = function (element, isFirst) {var img = element.thumbnail;
      var insertIndex = img.lastIndexOf('/');var
      isMobile = _this.props.isMobile;
      var url = '';
      if (global && global.window) {
        var width = window.innerWidth;
        var firstImgSize = isMobile ? 'h_400' : 'w_' + Math.round(width);
        var imgSize = isFirst ? firstImgSize : 'h_277';
        url = img.slice(0, insertIndex) + '/' + imgSize + img.slice(insertIndex);
      }

      return (
        _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(_this.props.locale, '/articles/' + element.id), key: element.id, className: _ArticlesPage2.default.article },
          _react2.default.createElement('div', { style: { backgroundImage: 'url(' + url + ')' }, className: _ArticlesPage2.default.picture }),
          _react2.default.createElement('div', { className: _ArticlesPage2.default.textPart },
            _react2.default.createElement('div', { className: _ArticlesPage2.default.textWrapper },
              _react2.default.createElement('div', { className: _ArticlesPage2.default.title }, element.title),
              _react2.default.createElement('div', { className: _ArticlesPage2.default.description }, element.description)))));




    }, _this.

    renderHelmet = function () {var _this$props =
      _this.props,route = _this$props.route,locale = _this$props.locale;
      var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);
      return (
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: _this.props.translate('title', 'titleTemplate')(),
          title: _this.props.translate('helmet', 'articlesTitle')(),
          meta: [
          { property: 'og:url', content: '' + _constants.shareUrl + route },
          { property: 'og:title', content: _this.props.translate('helmet', 'articlesTitle') + ' | \u202BOnMap' },
          { property: 'og:description', content: _this.props.translate('helmet', 'articlesDescription') },
          { name: 'description', content: _this.props.translate('helmet', 'articlesDescription') }].concat(
          _this.props.locale === 'fr' ? [{ name: 'robots', content: 'noindex,nofollow' }] : []),

          link: [].concat(
          multiLanguage, [
          { rel: 'canonical', href: '' + _constants.shareUrl + route }]) }));



    }, _this.

    renderH1 = function () {return (
        _react2.default.createElement('h1', { className: _ArticlesPage2.default.pageTitle },
          _this.props.translate('title', 'articles')));}, _temp), _possibleConstructorReturn(_this, _ret);}ArticlesPage.prototype.



  render = function render() {var _this2 = this;var
    articles = this.props.articles;
    if (articles.length) {
      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_ArticlesPage2.default.articlesWrapper, 'pageHeight') },
          this.renderHelmet(),
          this.renderH1(),
          this.renderArticle(articles[0], 'isFirst'),
          _react2.default.createElement('div', { className: _ArticlesPage2.default.articlesBlock },
            articles.slice(1).map(function (element) {return _this2.renderArticle(element);}))));



    }return _react2.default.createElement('div', { className: 'pageHeight' });
  };return ArticlesPage;}(_react.Component);


ArticlesPage.propTypes = {
  isMobile: _propTypes2.default.bool,
  articles: _propTypes2.default.array,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  route: _propTypes2.default.any };


var asyncData = [{
  key: 'articles',
  promise: function promise(_ref) {var store = _ref.store;var
    locale = store.getState().lang.locale;
    if (locale === 'fr') {
      return store.dispatch((0, _articles.receiveArticles)('en'));
    }
    return store.dispatch((0, _articles.receiveArticles)(locale));
  } }];


var mapStateToProps = function mapStateToProps(state) {return {
    articles: state.articles.articles,
    translate: (0, _reduxPagan.getLang)(state.lang, 'static') };};exports.default =


(0, _ramda.compose)(
(0, _reduxConnect.asyncConnect)(asyncData),
(0, _reactRedux.connect)(mapStateToProps))(
ArticlesPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ArticlesPage/ArticlesPage.js
// module id = 3080
// module chunks = 0